import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { GeneratingReportsStep } from "@src/widgets/onboarding/classes/tours/TransactionHistoryAndReportsTour/steps/GeneratingReportsStep"
import { TransactionHistoryStep } from "@src/widgets/onboarding/classes/tours/TransactionHistoryAndReportsTour/steps/TransactionHistoryStep"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class TransactionHistoryAndReportsTour extends BaseTour {
  name = ONBOARDING_TOURS.TRANSACTION_HISTORY_AND_REPORTS

  steps = [new TransactionHistoryStep(), new GeneratingReportsStep()]
}
